import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, Radios, UniversalSelect } from '@feathr/components';
import { flattenError } from '@feathr/hooks';

import type { IOtherActivityFieldOption } from '../GroupExportModal.utils';
import { getOtherActivityScopeOptions } from '../GroupExportModal.utils';
import TimeFrameField from '../TimeFrameField';
import type { IOtherActivitiesTabState } from './OtherActivitiesTab.hooks';

export interface IOtherActivitiesTabProps {
  state: IOtherActivitiesTabState;
}

function OtherActivitiesTab({ state }: Readonly<IOtherActivitiesTabProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const {
    selectedScope,
    isCustomFieldsPending,
    otherActivityFieldOptions,
    selectedFieldOptions,
    fieldsError,
    handleChangeScope,
    handleSelectFields,
  } = state;

  const scopeOptions = getOtherActivityScopeOptions(t).map((option) => ({
    id: option.id,
    name: option.label,
    tooltip: option.tooltip,
  }));

  function handleScopeChange(value?: string): void {
    if (value !== 'group' && value !== 'all') {
      return;
    }
    handleChangeScope(value);
  }

  return (
    <Fieldset>
      <Stack gap={theme.spacing['4']}>
        <Radios
          label={t('Activity')}
          layout={'block'}
          name={'other-activity-scope'}
          onChange={handleScopeChange}
          options={scopeOptions}
          orientation={'horizontal'}
          value={selectedScope}
        />
        <UniversalSelect<IOtherActivityFieldOption>
          isLoading={isCustomFieldsPending}
          isMulti={true}
          label={t('Fields')}
          menuPortalTarget={document.body}
          name={'other-activity-fields'}
          onSelectMulti={handleSelectFields}
          options={otherActivityFieldOptions}
          placeholder={t('Add a field')}
          validationError={flattenError(fieldsError)}
          value={selectedFieldOptions}
        />
        <TimeFrameField state={state} />
      </Stack>
    </Fieldset>
  );
}

export default OtherActivitiesTab;
